exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-display__profile-photo[data-v-43d5fd19]{border-radius:50%}.media-display__iframe-border[data-v-43d5fd19]{border:none}", ""]);

// exports
